import remove from 'lodash-es/remove';
import { mutator } from 'satcheljs';
import {
    addPickerSections,
    updatePickerOptions,
    updatePickerSections,
    removePickerOption,
} from '../actions/pickerOptionsActions';

mutator(addPickerSections, ({ viewState, option }) => {
    // Always add primary account options at the beggining
    if (option.isPrimaryAccount) {
        viewState.options.unshift(option);
    } else {
        viewState.options.push(option);
    }
});

mutator(updatePickerSections, ({ option, leafOptions }) => {
    option.leafOptions = leafOptions;
});

mutator(updatePickerOptions, ({ viewState, options }) => {
    viewState.options = options;
});

mutator(removePickerOption, ({ viewState, option }) => {
    remove(viewState.options, opt => opt.account === option.account);
});
